import { ChangeDetectionStrategy, Component, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-server-error',
  standalone: true,
  template: `
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card">
            <div class="card-body text-center">
              <h1 class="display-6 mb-3">Server Error</h1>
              <p class="lead mb-4">Something went wrong during initialization.</p>
              <p class="text-muted">Error code: 500</p>
              <div class="mt-4 d-flex gap-2 justify-content-center">
                <button class="btn btn-outline-secondary" (click)="retry()">Retry</button>
                <button class="btn btn-primary" (click)="returnToLogin()">Return to Login</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServerErrorComponent {
  private platformId = inject(PLATFORM_ID);

  retry(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Clear the bootstrap error flag and attempt reload
    this.clearSession();
    window.location.href = '/';
  }

  returnToLogin(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Clear all session data and redirect to login
    this.clearSession();
    localStorage.removeItem('user');
    window.location.href = '/login';
  }

  private clearSession(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    sessionStorage.removeItem('bootstrapError');
    sessionStorage.removeItem('waitPageRedirectCount');
    sessionStorage.removeItem('redirectUrl');
  }
}
